import React,{ useEffect } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import Blockchain from "../snippets/BlockchainNetwork";
import BlockNode from "../snippets/BlockchainNode";
import PrivateKey from "../snippets/PrivateKeys";
import SmartContracts from "../snippets/SmartContracts";
import { postuserstatus } from "../API/ApiFunctions";

const Home = () => {

    return (
        <div class="py-5">
            <div class="container">
                {/* <div className="mb-5">
                    <h1 className="display-4 mb-3">Pricing Calculator</h1>
                    <h4 className="mb-3">Sigma pricing is simple: you only pay for what you use.</h4>
                    <p className="lead">Pick the services you need for your project, and configure them to your needs. Sigma follows a metered pay-as-you-go model, and charges you only based on the services you use, and the resources (memory, vCPU, and disk space) you need to keep these services up and running. You can add as many of each service as you want.</p>
                </div> */}
                <Row>
                    <Col md={7} className="mb-md-0 mb-4">
                        <Blockchain />
                        <BlockNode />
                        <SmartContracts />
                        <PrivateKey />
                    </Col>
                    <Col md={5}>
                        <Card className="card-dark mb-3">
                            <Card.Body className="p-3">
                                <h4 className="mb-3">Total cost</h4>
                                <div className="d-flex total-cost-list align-items-center">
                                    <p className="mb-0"><strong>Blockchain Node</strong><br />Create private keys to keep your funds and smart contracts secure.</p>
                                    <small className="text-nowrap px-3" style={{opacity: 0.5}}>€0.01/h <br />€7.20/m</small>
                                    <Button className="p-0" variant="reset">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000" class="bi bi-trash-fill" viewBox="0 0 16 16">
                                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                                        </svg>
                                    </Button>
                                </div>
                                <div className="d-flex total-cost-list align-items-center">
                                    <p className="mb-0"><strong>Blockchain Node</strong><br />Create private keys to keep your funds and smart contracts secure.</p>
                                    <small className="text-nowrap px-3" style={{opacity: 0.5}}>€0.01/h <br />€7.20/m</small>
                                    <Button className="p-0" variant="reset">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000" class="bi bi-trash-fill" viewBox="0 0 16 16">
                                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                                        </svg>
                                    </Button>
                                </div>
                                <hr />
                                <div className="py-2 total-bottom">
                                    <div className="text-end">
                                        <h3><strong>€0.94</strong>/hour</h3>
                                        <h6><strong>€676.80</strong>/month</h6>
                                        <Button variant="link" className="p-0">Clear</Button>
                                    </div>
                                </div>
                                <a href="/" className="btn w-100 justify-content-center d-flex align-items-center btn-primary"> 
                                    <span className="me-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
                                        </svg>
                                    </span>
                                    Send via email
                                </a>
                            </Card.Body>
                        </Card>

                        <Card className="card-dark mb-3">
                        {localStorage.getItem('Login') === true || localStorage.getItem('Login') || localStorage.getItem('Login') ==="true" ?
                        (<>
                        
                        <Card.Body className="px-3 text-center py-4">
                                 {/* <h4 className="mb-0">Get €250 to try Sigma!</h4>  */}
                                <div className="py-3">
                               
                                    <a href="/dashboard" className="btn btn-primary"> 
                                       View Dashboard
                                    </a>
                                </div>
                                {/* <a href="/" className="btn-link">Or get in touch for more info</a> */}
                            </Card.Body>
                        
                        
                        </>):(<>
                        
                        
                        <Card.Body className="px-3 text-center py-4">
                                <h4 className="mb-0">Get €250 to try Sigma!</h4>
                                <div className="py-3">
                               
                                    <a href="/Login" className="btn btn-primary"> 
                                        START FOR FREE
                                    </a>
                                </div>
                                <a href="/" className="btn-link">Or get in touch for more info</a>
                            </Card.Body>
                        
                        
                        </>)        }
                            
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
  };
  
  export default Home;